// 一些固有设定
const equipTypes = {
  weapon: "weapon", //武器
  lorica: "lorica", //胸甲
  necklace: "necklace" //项链
};
const equipTypesNames = {
  weapon: "武器", //武器
  lorica: "上衣", //胸甲
  necklace: "项链" //项链
};
// 装备品级
const equipGradeName = {
  0: "普通",
  1: "高级",
  2: "稀有",
  3: "神器",
  4: "传说",
  5: "史诗",
  6: "神话"
};
const equipGrowth = 1.05; // 装备成长系数
const equipAffixFac = 0.2; // 前后缀生成系数
const equipFloatF = 0.2; // 词条浮动系数
const equipTotalProps = {
  STR: 0,
  STRP: 0,
  VIT: 0,
  VITP: 0,
  DEX: 0,
  DEXP: 0,
  HP: 0,
  HPP: 0,
  RHP: 0,
  RHPP: 0,
  ATK: 0,
  ATKP: 0,
  DEF: 0,
  DEFP: 0,
  AS: 0,
  ASP: 0,
  CRR: 0,
  CRRP: 0,
  CRD: 0,
  CRDP: 0
};
type EquipTotalPropsType = typeof equipTotalProps;
export {
  equipTypes,
  equipGradeName,
  equipTypesNames,
  equipGrowth,
  equipAffixFac,
  equipFloatF,
  equipTotalProps,
  EquipTotalPropsType
};
